import './App.css'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './components/Home'
import Users from './components/Users'
import Project from './components/Project'
import Viewer from './components/Viewer'
import Command from './helpers/Command'
import { enableMapSet } from 'immer'

import { setupUserInputMessenger } from './helpers/user-input-messenger'
import { Login } from "./components/login/Login"
import { RepoLogin } from "./components/login/RepoLogin"
import { ProtectedRoute } from "./components/ProtectedRoute"
import { useEffect } from 'react'
import { useFeatureFlags } from './flags'
import { StandaloneSparqlPage, StandaloneToolPage } from './components/StandaloneToolPage'
import { V2Layout } from './v2/shared/v2-layout'
import { HomeV2 } from './v2/pages/home-v2'
import { UsersV2 } from './v2/pages/users-v2'
import { ProjectV2 } from './v2/pages/project-v2'

enableMapSet()
setupUserInputMessenger()

declare global {
  interface Window {
    CONNECTED_APPS_STATIC: any // lock&publish
  }
}

if (window.top) {
  (window.top as any).command = Command;
  //window.top.window.command=Command; /// handy for wistor apps running in a iframe
}

const wistorArt
  = " __      __.__          __                \r\n"
  + "/  \\    /  \\__| _______/  |_  ___________ \r\n"
  + "\\   \\/\\/   /  |/  ___/\\   __\\/  _ \\_  __ \\\r\n"
  + " \\        /|  |\\___ \\  |  | (  <_> )  | \\/\r\n"
  + "  \\__/\\  / |__/____  > |__|  \\____/|__|   \r\n"
  + "       \\/          \\/                     \r\n"

export function App() {
  if (window.CONNECTED_APPS_STATIC) {
    return <StaticApp />
  }

  return <PlatformApp />
}

function StaticApp() {
  return (
    <Router>
      <Switch>
          <Route path="/" exact component={Viewer} />
          <Route path="/loginbb" component={RepoLogin} />
          <Route path="*" component={Viewer} />
      </Switch>
    </Router>
  )
}

function PlatformApp() {
  const localModeIsActive = useFeatureFlags().localMode
  useEffect(() => { console.log(wistorArt) }, [])

  if (localModeIsActive) return (
    <Router>
      <Switch>
        <Route path="/:mode(edit)?" component={Viewer} />
      </Switch>
    </Router>
  )

  return (
    <Router>
      <div className="app">
        <ProtectedRoute path="/" exact component={Home} />
        <Route path="/loginbb" component={RepoLogin} />
        <Route path="/login" component={Login} />
        <ProtectedRoute path="/users" component={Users} />
        <ProtectedRoute path="/projects/:projectPath" exact component={Project} />
        <ProtectedRoute
          protectIf={match => (match?.params as any)?.mode === "edit"}
          path="/projects/:projectPath/:viewerPath/:mode(edit)?"
          component={Viewer}
          />
        <ProtectedRoute exact path="/tools/sparql" component={StandaloneSparqlPage} />
        <ProtectedRoute exact path="/tools/:toolName" component={StandaloneToolPage} />
        <Route path="/v2" render={() => (
          <V2Layout>
            <Switch>
              <ProtectedRoute exact path="/v2/home" component={HomeV2} />
              <ProtectedRoute exact path="/v2/users" component={UsersV2} />
              <ProtectedRoute exact path="/v2/projects/:projectPath" component={ProjectV2} />
            </Switch>
          </V2Layout>
        )} />
      </div>
    </Router>
  )
}